/**
 * Color utils
 */
import { CourseLightModel, CourseModel, type SessionLightModel, type SessionModel } from "@24hbs/utils";
import { useCourseCategoryUtils } from "$lib/utils/courses/category-utils";
import type { ICourseCategoryFields } from "$lib/utils/contentful/types";
import { colors } from "./config/colors";

type CategoryKeys = keyof typeof colors.categories;
import { browser } from "$app/environment";

/**
 * Set :root --tint-color variable by course
 */
export const setTintColorByCourse = async (course: SessionModel | SessionLightModel | CourseModel | CourseLightModel) => {
  const session: SessionModel | SessionLightModel | null = (course instanceof CourseModel || course instanceof CourseLightModel) ? course.getMainSession() : course;

  if (!session) {
    console.log('Session not found');
    return;
  }

  const courseCategoryUtils = useCourseCategoryUtils(fetch);
  const courseCategory: ICourseCategoryFields | null = await courseCategoryUtils.getCourseCategoryByName(session.categories[0]);

  if (!courseCategory) {
    console.log('Course category not found');
    return;
  }

  // Transform category slug to CamelCase
  const categorySlug = courseCategory.slug;
  const categorySlugCamelCase = categorySlug.replace(/-([a-z])/g, (g) => g[1].toUpperCase());

  const color: string = colors.categories[categorySlugCamelCase as CategoryKeys]?.DEFAULT || '';
  const constrastColor: string = colors.categories[categorySlugCamelCase as CategoryKeys]?.text || '';

  // Set color variable
  if (browser) {
    document.documentElement.style.setProperty('--tint-color', color);
    document.documentElement.style.setProperty('--tint-contrast-color', constrastColor);
  }
};
